import { ENV_VARS } from '@/env';

// we have only one entrypoint via api path
const BASE = `${ENV_VARS.REACT_APP_API_URL}/api`;
const BASE_ORIGIN = `${ENV_VARS.REACT_APP_ORIGIN_API}/api`;

export const API = {
  BASE,
  BASE_ORIGIN,
  AUCTION: `${BASE}/AuctionAPI`,
  SECURITY: `${BASE}/SecurityAPI`,
  PRIMARY: `${BASE}/PrimaryAPI`,
  SHIPMENT: `${BASE}/ShipmentAPI`,
  LOSS_AND_DAMAGE: `${BASE}/LossAndDamageAPI`,
  OVERCHARGE_CLAIM: `${BASE}/OverchargeClaimAPI`,
  PRECLAIM: `${BASE}/PreClaimAPI`,
  QUOTE_DASHBOARD: `${BASE}/QuoteDashboard`,
  QUOTE_DASHBOARD_V2: `${BASE}/spot-quote/dashboard/bids`,
  DASHBOARD: `${BASE}/Dashboard`,
  MESSAGE_CENTER: `${BASE}/MessageCenterAPI`,
  PovAPI: `${BASE}/PovAPI`,
  POV: `${BASE}/PovAPI`,
  // TODO: verify looks like API isn't case-sensitive
  POV2: `${BASE}/POVAPI`,
  PROCUREMENT: `${BASE}/ProcurementAPI`,
  PO: `${BASE}/PoAPI`,
  SPOT_QUOTE: `${BASE}/SpotQuote`,
  // TODO: verify looks like API isn't case-sensitive
  SPOT_QUOTE2: `${BASE}/spotquote`,
  SPOT_QUOTE_V2: `${BASE}/spot-quote`,
  MASTER_SETTINGS: `${BASE}/MasterSettingsAPI`,
  VISIBILITY: `${BASE}/VisibilityAPI`,
  SAVERS: `${BASE}/Savers`,
  ROUTING_GUIDE: `${BASE}/RoutingGuideAPI`,
  SPOT_QUOTE_ROUTING_GUIDE_V2: `${BASE}/spot-quote/routing-guide`,
  PDF_EXPORT: `${BASE}/PDFExport`,
  CARRIER_EMAIL_REGISTRATION: `${BASE}/CarrierEmailRegistration`,
};
